import { companyAPI } from '@/services-ts/axios'
import type { IHoliday } from '@/types/Data'
import type { IGetHolidayList, IPayloadHoliday } from '@/types/Request'
import type { IHolidayStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useHolidayStore = defineStore('holiday', {
  state: (): IHolidayStore => ({
    holidays: {
      data: [],
      total: 0,
    },
  }),
  actions: {
    async GetHolidayList(payload: IGetHolidayList): Promise<{ data: IHoliday[]; total: number }> {
      const { data, total, status } = await companyAPI.HolidayServices.GetHolidayList(payload)

      this.holidays = status ? { data, total: total || 0 } : { data: [], total: 0 }
      return this.holidays
    },

    async CreateHoliday(payload: IPayloadHoliday): Promise<boolean> {
      const { status, data } = await companyAPI.HolidayServices.CreateHoliday(payload)

      if (status) {
        this.holidays.data.push(data)
        this.holidays.total += 1

        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
      return status
    },

    async UpdateHoliday(payload: IPayloadHoliday): Promise<boolean> {
      const { status } = await companyAPI.HolidayServices.UpdateHoliday(payload)

      if (status) {
        const index = this.holidays.data.findIndex(holiday => holiday.id === payload.id)
        if (this.holidays.data[index]) {
          this.holidays.data[index] = { ...this.holidays.data[index], ...payload }
        }
        void Alert({
          message: Format('admin_global_updated'),
          type: 'success',
        })
      }
      return status
    },

    async DeleteHoliday(id: string): Promise<boolean> {
      const { status } = await companyAPI.HolidayServices.DeleteHoliday(id)

      this.holidays.data = this.holidays.data.filter(holiday => holiday.id !== id)
      if (status) {
        void Alert({
          message: Format('admin_global_deleted'),
          type: 'success',
        })
      }
      return status
    },
  },
})
